export const OPTHINES = {
  voteName: '2020project/2020homefurnishing',
  themeColor: {
    activeBgColor: 'rgb(2,2,76)',
    inactiveBgColor: 'white',
  },
  placeholder: '搜索作品名称/姓名',
  tabs: [
    {
      tabName: '相关新闻',
      tabPath: '/20200224SHZLM/news',
    },
    {
      tabName: '活动介绍',
      tabPath: '/20200224SHZLM/rules',
    },
  ],
};

